import React, { useState, useEffect } from "react";
import { COLORS, Typo } from "../../../layout/theme";
import { DrawerContainer, FilterContainerButton, Inner } from "./styles";
import {
	export_dashboard_products,
	get_chain_laboratory_dashboard,
	get_dinamic_mobile_dashboard,
	get_dinamic_sales_dashboard,
	get_initiatives_dashboard,
	get_pharmacy_laboratory_dashboard,
	get_products_laboratory_dashboard,
} from "../../../../api/endpoints/dashboard";
import LoadingSkeleton from "./components/loading-skeleton/LoadingSkeleton";
import { useAuth } from "../../../../contexts/authContext";
import {
	BarChartOutlined,
	MobileOutlined,
	CloseCircleOutlined,
	ClusterOutlined,
} from "@ant-design/icons";
import { numberWithDotAndCommas } from "../../../../utils/numberWithDotAndComas";
import { CONSTANTS } from "../../../../utils/constants";
import moment from "moment";
import { Layout, Menu, Tooltip } from "antd";
import SaleDashboard from "./components/dashboards/SaleDashboard";
import MobileDashboard from "./components/dashboards/MobileDashboard";
import { useFilter } from "../../../../contexts/filterContext";
import { FaBoxes, FaInfo } from "react-icons/fa";
import { numberToMillions } from "../../../../utils/numberToMillions";
import { TiPlusOutline } from "react-icons/ti";
import PharmacyDashboard from "./components/dashboards/PharmacyDashboard";
import ProductDashboard from "./components/dashboards/ProductDashboard";
import InitiativeDashboard from "./components/dashboards/InitiativeDashboard";
import { BiTrendingUp } from "react-icons/bi";
import ChainDashboard from "./components/dashboards/ChainDashboard";
const { Sider } = Layout;

export default function DashboardSeller({ clientId, clientUser }) {
	const { user, userdata } = useAuth();
	const {
		selectedDistributor,
		setSelectedDistributor,
		selectedPharmacy,
		setSelectedPharmacy,
		rangeDate,
		setRangeDate,
		dateFrom,
		setDateFrom,
		dateTo,
		setDateTo,
		mobilePeriod,
		setMobilePeriod,
		selectedFilters,
		setSelectedFilters,
		setSelectedTypeOfSale,
		selectedSellerList,
		setSelectedSellerList,
		sellerDashboardDisplay,
		setSellerDashboardDisplay,
		selectedCategory,
		setSelectedCategory,
		selectedChain,
		setSelectedChain,
		selectedBrand,
		setSelectedBrand,
		selectedInitiative,
		setSelectedInitiative,
		salesPeriod,
		setSalesPeriod,
		chainsPeriod,
		setChainsPeriod,
		pharmaciesPeriod,
		setPharmaciesPeriod,
		productsPeriod,
		setProductsPeriod,
		initiativesPeriod,
		setInitiativesPeriod,
	} = useFilter();
	const [collapsed, setCollapsed] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [distributorsD2, setDistributorsD2] = useState(null);
	const [categoriesD2, setCategoriesD2] = useState(null);
	const [chainD2, setChainD2] = useState(null);
	const [usersD2, setUsersD2] = useState(null);
	const [generalInfoD2, setGeneralInfoD2] = useState(null);
	const [pieDataD2, setPieDataD2] = useState(null);
	const [timeSalesGraphD2, setTimeSalesGraphD2] = useState(null);
	const [timeOrdersGraphD2, setTimeOrdersGraphD2] = useState(null);
	const [timeUnitsGraphD2, setTimeUnitsGraphD2] = useState(null);
	const [categoryGraphSelector2D2, setCategoryGraphSelector2D2] =
		useState("SALES");
	const [secondPieDataD2, setSecondPieDataD2] = useState(null);
	const [thirdPieDataD2, setThirdPieDataD2] = useState(null);
	const [timeCategoriesSalesGraphD2, setTimeCategoriesSalesGraphD2] =
		useState(null);
	const [timeCategoriesUnitsGraphD2, setTimeCategoriesUnitsGraphD2] =
		useState(null);
	const [timeHistoricSalesGraphD2, setTimeHistoricSalesGraphD2] =
		useState(null);
	const [salesInfoSelectorD2, setSalesInfoSelectorD2] = useState("SALES");
	const [dateFromD2, setDateFromD2] = useState(
		moment().startOf("month").format("MM-DD-YYYY").toString()
	);
	const [dateToD2, setDateToD2] = useState(
		moment().endOf("month").format("MM-DD-YYYY").toString()
	);
	const [rangeDateD2, setRangeDateD2] = useState([
		moment().startOf("month"),
		moment().endOf("month"),
	]);

	const [distributorsD3, setDistributorsD3] = useState(null);
	const [usersD3, setUsersD3] = useState(null);
	const [dateFromD3, setDateFromD3] = useState(
		moment().startOf("month").format("MM-DD-YYYY").toString()
	);
	const [dateToD3, setDateToD3] = useState(
		moment().endOf("month").format("MM-DD-YYYY").toString()
	);
	const [rangeDateD3, setRangeDateD3] = useState([
		moment().startOf("month"),
		moment().endOf("month"),
	]);
	const [categoriesD3, setCategoriesD3] = useState(null);
	const [generalInfoD3, setGeneralInfoD3] = useState(null);
	const [timePharmacyOrdersGraphD3, setTimePharmacyOrdersGraphD3] =
		useState(null);
	const [sellerSalesTableD3, setSellerSalesTableD3] = useState(null);
	const [ordersInfoSelector, setOrdersInfoSelector] = useState("UNITS");
	const [distributorsPieInfoSelector, setDistributorsPieInfoSelector] =
		useState("SALES");
	const [openFilterList, setOpenFilterList] = useState(false);
	const [distributorsD4, setDistributorsD4] = useState(null);
	const [pharmaciesD4, setPharmaciesD4] = useState(null);
	const [chainsD4, setChainsD4] = useState(null);
	const [usersD4, setUsersD4] = useState(null);
	const [categoriesD4, setCategoriesD4] = useState(null);
	const [generalInfoD4, setGeneralInfoD4] = useState(null);
	const [pharmaciesTable, setPharmaciesTable] = useState(null);
	const [dateFromD4, setDateFromD4] = useState(
		moment().startOf("month").format("MM-DD-YYYY").toString()
	);
	const [dateToD4, setDateToD4] = useState(
		moment().endOf("month").format("MM-DD-YYYY").toString()
	);
	const [rangeDateD4, setRangeDateD4] = useState([
		moment().startOf("month"),
		moment().endOf("month"),
	]);

	const [generalInfoD5, setGeneralInfoD5] = useState(null);
	const [distributorsD5, setDistributorsD5] = useState(null);
	const [categoriesD5, setCategoriesD5] = useState(null);
	const [brandsD5, setBrandsD5] = useState(null);
	const [chainsD5, setChainsD5] = useState(null);
	const [usersD5, setUsersD5] = useState(null);
	const [productsTable, setProductsTable] = useState(null);
	const [dateFromD5, setDateFromD5] = useState(
		moment().startOf("month").format("MM-DD-YYYY").toString()
	);
	const [dateToD5, setDateToD5] = useState(
		moment().endOf("month").format("MM-DD-YYYY").toString()
	);
	const [rangeDateD5, setRangeDateD5] = useState([
		moment().startOf("month"),
		moment().endOf("month"),
	]);

	const [generalInfoD6, setGeneralInfoD6] = useState(null);
	const [distributorsD6, setDistributorsD6] = useState(null);
	const [categoriesD6, setCategoriesD6] = useState(null);
	const [chainsD6, setChainsD6] = useState(null);
	const [usersD6, setUsersD6] = useState(null);
	const [initiativesD6, setInitiativesD6] = useState(null);
	const [productTotalvsInitiativesD6, setProductTotalvsInitiativesD6] =
		useState(null);
	const [timeInitiativesSalesGraphD6, setTimeInitiativesSalesGraphD6] =
		useState(null);
	const [timeInitiativesUnitsGraphD6, setTimeInitiativesUnitsGraphD6] =
		useState(null);
	const [initiativeGraphSelectorD6, setInitiativeGraphSelectorD6] =
		useState("SALES");
	const [dateFromD6, setDateFromD6] = useState(
		moment().startOf("month").format("MM-DD-YYYY").toString()
	);
	const [dateToD6, setDateToD6] = useState(
		moment().endOf("month").format("MM-DD-YYYY").toString()
	);
	const [rangeDateD6, setRangeDateD6] = useState([
		moment().startOf("month"),
		moment().endOf("month"),
	]);

	const [distributorsD7, setDistributorsD7] = useState(null);
	const [chainsD7, setChainsD7] = useState(null);
	const [usersD7, setUsersD7] = useState(null);
	const [categoriesD7, setCategoriesD7] = useState(null);
	const [generalInfoD7, setGeneralInfoD7] = useState(null);
	const [chainsTable, setChainsTable] = useState(null);
	const [dateFromD7, setDateFromD7] = useState(
		moment().startOf("month").format("MM-DD-YYYY").toString()
	);
	const [dateToD7, setDateToD7] = useState(
		moment().endOf("month").format("MM-DD-YYYY").toString()
	);
	const [rangeDateD7, setRangeDateD7] = useState([
		moment().startOf("month"),
		moment().endOf("month"),
	]);
	const [applyFilters, setApplyFilters] = useState(false);

	const fetch_sales_dashboard = async () => {
		setIsLoading(true);
		try {
			const res = await get_dinamic_sales_dashboard(
				selectedDistributor,
				clientId,
				dateFromD2,
				dateToD2,
				selectedCategory,
				selectedChain,
				selectedSellerList
			);
			const resDistributorsD2 = JSON.parse(res?.generalInfo?.distributorList);
			const resCategoriesD2 = JSON.parse(res?.generalInfo?.categoryList);
			const resChainsD2 = JSON.parse(res?.generalInfo?.chainList);
			const resSellersD2 = JSON.parse(res?.generalInfo?.sellerList);

			setDistributorsD2(
				resDistributorsD2?.map((r) => ({
					value: r.DistributorId,
					label: r.DistributorName,
				}))
			);

			setCategoriesD2(
				resCategoriesD2?.map((r) => ({
					value: r.Id,
					label: r.Name,
				}))
			);

			setChainD2(
				resChainsD2?.map((r) => ({
					value: r.ChainId,
					label: r.ChainName,
				}))
			);

			setUsersD2(
				resSellersD2?.map((r) => ({
					value: r.SellerId,
					label: r.SellerFirstName + " " + r.SellerLastName,
				}))
			);

			setGeneralInfoD2(res?.generalInfo);

			let counter = 0;

			setPieDataD2({
				chart: {
					type: "variablepie",
					height: "100%",
				},
				title: {
					style: { display: "none" },
				},
				credits: { enabled: false },
				tooltip: {
					pointFormat: "<b>{point.y}</b>",
				},
				legend: {
					layout: "vertical",
					align: "right",
					verticalAlign: "top",
					x: 0,
					y: 10,
					floating: false,
				},
				plotOptions: {
					variablepie: {
						size: "150",
						cursor: "pointer",
						dataLabels: {
							enabled: true,
							color: COLORS.Secondary,
							connectorColor: COLORS.Secondary,
							useHTML: true,
							formatter: function () {
								counter++;
								return (
									'<div key={"label_"' +
									counter +
									'} style={{display: "flex", flexDirection: "column"}}><div style={{width: "100%", whiteSpace: "nowrap", overflow: "hidden !important", textOverflow: "ellipsis"}}><b>' +
									this.point.name +
									"</b>: </div><div>" +
									this.percentage.toFixed(0) +
									" %</div></div>"
								);
							},
						},
						showInLegend: true,
						center: ["55%", "18%"],
						colors: [
							COLORS.Primary,
							COLORS.Secondary,
							COLORS.Success,
							COLORS.StrongGreen,
							COLORS.Danger,
							COLORS.Brown,
							COLORS.Warning,
							COLORS.Violet,
							COLORS.Purple,
							COLORS.Grey,
						],
					},
				},
				series: [
					{
						type: "variablepie",
						zMin: 0,
						name: "Droguerias",
						data: res?.distributorOrders?.map((dist, idx) => ({
							name: dist.distributorName,
							y: dist.totalInOrders,
							z: 100,
						})),
					},
				],
			});

			setTimeSalesGraphD2({
				chart: { type: "spline" },
				title: {
					text: undefined,
				},
				tooltip: {
					shared: true,
					formatter: function () {
						return (
							"<b>" + this.x + "</b></br>$ " + numberWithDotAndCommas(this.y)
						);
					},
				},
				legend: {
					enabled: false,
				},
				colors: [COLORS.Default, COLORS.Grey],
				credits: { enabled: false },
				xAxis: {
					categories: res?.ordersByYearAndMonth.map(
						(p) => CONSTANTS.CALENDAR_MONTHS[p.saleMonth]
					),
				},
				yAxis: {
					visible: true,
					title: {
						text: null,
					},
					labels: {
						enabled: true,
					},
					gridLineColor: "#197F07",
					gridLineWidth: 0,
					lineWidth: 1,
					plotLines: [
						{
							color: "#FF0000",
							width: 1,
							value: 0,
						},
					],
					stackLabels: {
						enabled: true,
						style: {
							color: COLORS.MediumGrey,
							textOutline: 0,
						},
						y: -8,
						overflow: "allow",
						crop: false,
						formatter: function () {
							if (
								this.x ===
									this.axis.series[0]?.xData[
										this.axis.series[0]?.xData.length - 2
									] &&
								this.axis.series[0]?.data[this.axis.series[0]?.data.length - 1]
									?.category ===
									CONSTANTS.CALENDAR_MONTHS[res.generalInfo.actualMonth]
							) {
								return numberToMillions(this.total);
							} else {
								return null;
							}
						},
					},
				},
				plotOptions: {
					series: {
						stacking: "normal",
					},
				},
				series: [
					{
						name: "",
						data: res?.ordersByYearAndMonth.map((p) => p.totalSales),
						lineWidth: 2,
						lineColor: COLORS.Success,
						marker: {
							fillColor: COLORS.Secondary,
							lineWidth: 2,
							lineColor: COLORS.Secondary,
							symbol: "circle",
							radius: 3,
						},
						zoneAxis: "x",
						zones: [
							{
								value:
									res?.ordersByYearAndMonth[res.ordersByYearAndMonth.length - 1]
										?.saleMonth === res.generalInfo.actualMonth
										? res?.ordersByYearAndMonth.length - 2
										: res?.ordersByYearAndMonth.length,
								color: COLORS.Success,
							},
							{
								color: COLORS.LightSuccess,
							},
						],
					},
				],
			});

			setTimeOrdersGraphD2({
				chart: { type: "spline" },
				title: {
					text: undefined,
				},
				tooltip: {
					shared: true,
					formatter: function () {
						return "<b>" + this.x + "</b></br>" + this.y;
					},
				},
				legend: {
					enabled: false,
				},
				colors: [COLORS.Default, COLORS.Grey],
				credits: { enabled: false },
				xAxis: {
					categories: res?.totalOrdersByYearAndMonth.map(
						(p) => CONSTANTS.CALENDAR_MONTHS[p.saleMonth]
					),
				},
				yAxis: {
					visible: true,
					title: {
						text: null,
					},
					labels: {
						enabled: true,
					},
					gridLineColor: "#197F07",
					gridLineWidth: 0,
					lineWidth: 1,
					plotLines: [
						{
							color: "#FF0000",
							width: 1,
							value: 0,
						},
					],
					stackLabels: {
						enabled: true,
						style: {
							color: COLORS.MediumGrey,
							textOutline: 0,
						},
						y: -8,
						overflow: "allow",
						crop: false,
						formatter: function () {
							if (
								this.x ===
									this.axis.series[0]?.xData[
										this.axis.series[0]?.xData.length - 2
									] &&
								this.axis.series[0]?.data[this.axis.series[0]?.data.length - 1]
									?.category ===
									CONSTANTS.CALENDAR_MONTHS[res.generalInfo.actualMonth]
							) {
								return this.total;
							} else {
								return null;
							}
						},
					},
				},
				plotOptions: {
					series: {
						stacking: "normal",
					},
				},
				series: [
					{
						name: "",
						data: res?.totalOrdersByYearAndMonth.map((p) => p.totalOrders),
						lineWidth: 2,
						lineColor: COLORS.Secondary,
						marker: {
							fillColor: COLORS.Success,
							lineWidth: 2,
							lineColor: COLORS.Success,
							symbol: "circle",
							radius: 3,
						},
						zoneAxis: "x",
						zones: [
							{
								value:
									res?.totalOrdersByYearAndMonth[
										res.totalOrdersByYearAndMonth.length - 1
									]?.saleMonth === res.generalInfo.actualMonth
										? res?.totalOrdersByYearAndMonth.length - 2
										: res?.totalOrdersByYearAndMonth.length,
								color: COLORS.Secondary,
							},
							{
								color: COLORS.LightSecondary,
							},
						],
					},
				],
			});

			setSecondPieDataD2({
				chart: {
					type: "variablepie",
					height: "100%",
				},
				title: {
					style: { display: "none" },
				},
				credits: { enabled: false },
				tooltip: {
					pointFormat: "<b>{point.y}</b>",
				},
				legend: {
					layout: "vertical",
					align: "right",
					verticalAlign: "top",
					x: 0,
					y: 10,
					floating: false,
				},
				plotOptions: {
					variablepie: {
						size: "150",
						cursor: "pointer",
						dataLabels: {
							enabled: true,
							color: COLORS.Secondary,
							connectorColor: COLORS.Secondary,
							useHTML: true,
							formatter: function () {
								counter++;
								return (
									'<div key={"label_"' +
									counter +
									'} style={{display: "flex", flexDirection: "column"}}><div style={{width: "100%", whiteSpace: "nowrap", overflow: "hidden !important", textOverflow: "ellipsis"}}><b>' +
									this.point.name +
									"</b>: </div><div>" +
									this.percentage.toFixed(0) +
									" %</div></div>"
								);
							},
						},
						showInLegend: true,
						center: ["55%", "18%"],
						colors: [
							COLORS.Primary,
							COLORS.Secondary,
							COLORS.Success,
							COLORS.StrongGreen,
							COLORS.Danger,
							COLORS.Brown,
							COLORS.Warning,
							COLORS.Violet,
							COLORS.Purple,
							COLORS.Grey,
						],
					},
				},
				series: [
					{
						type: "variablepie",
						zMin: 0,
						name: "Droguerias",
						data: res?.distributorSales?.map((dist, idx) => ({
							name: dist.distributorName,
							y: dist.totalInOrders,
							z: 100,
						})),
					},
				],
			});

			setThirdPieDataD2({
				chart: {
					type: "variablepie",
					height: "100%",
				},
				title: {
					style: { display: "none" },
				},
				credits: { enabled: false },
				tooltip: {
					pointFormat: "<b>{point.y}</b>",
				},
				legend: {
					layout: "vertical",
					align: "right",
					verticalAlign: "top",
					x: 0,
					y: 10,
					floating: false,
				},
				plotOptions: {
					variablepie: {
						size: "150",
						cursor: "pointer",
						dataLabels: {
							enabled: true,
							color: COLORS.Secondary,
							connectorColor: COLORS.Secondary,
							useHTML: true,
							formatter: function () {
								counter++;
								return (
									'<div key={"label_"' +
									counter +
									'} style={{display: "flex", flexDirection: "column"}}><div style={{width: "100%", whiteSpace: "nowrap", overflow: "hidden !important", textOverflow: "ellipsis"}}><b>' +
									this.point.name +
									"</b>: </div><div>" +
									this.percentage.toFixed(0) +
									" %</div></div>"
								);
							},
						},
						showInLegend: true,
						center: ["55%", "18%"],
						colors: [
							COLORS.Primary,
							COLORS.Secondary,
							COLORS.Success,
							COLORS.StrongGreen,
							COLORS.Danger,
							COLORS.Brown,
							COLORS.Warning,
							COLORS.Violet,
							COLORS.Purple,
							COLORS.Grey,
						],
					},
				},
				series: [
					{
						type: "variablepie",
						zMin: 0,
						name: "Droguerias",
						data: res?.distributorSales?.map((dist, idx) => ({
							name: dist.distributorName,
							y: dist.totalUnits,
							z: 100,
						})),
					},
				],
			});

			setTimeUnitsGraphD2({
				chart: { type: "spline" },
				title: {
					text: undefined,
				},
				tooltip: {
					shared: true,
					formatter: function () {
						return "<b>" + this.x + "</b></br>" + this.y;
					},
				},
				legend: {
					enabled: false,
				},
				colors: [COLORS.Default, COLORS.Grey],
				credits: { enabled: false },
				xAxis: {
					categories: res?.ordersByYearAndMonth.map(
						(p) => CONSTANTS.CALENDAR_MONTHS[p.saleMonth]
					),
				},
				yAxis: {
					visible: true,
					title: {
						text: null,
					},
					labels: {
						enabled: true,
					},
					gridLineColor: "#197F07",
					gridLineWidth: 0,
					lineWidth: 1,
					plotLines: [
						{
							color: "#FF0000",
							width: 1,
							value: 0,
						},
					],
					stackLabels: {
						enabled: true,
						style: {
							color: COLORS.MediumGrey,
							textOutline: 0,
						},
						y: -8,
						overflow: "allow",
						crop: false,
						formatter: function () {
							if (
								this.x ===
									this.axis.series[0]?.xData[
										this.axis.series[0]?.xData.length - 2
									] &&
								this.axis.series[0]?.data[this.axis.series[0]?.data.length - 1]
									?.category ===
									CONSTANTS.CALENDAR_MONTHS[res.generalInfo.actualMonth]
							) {
								return this.total;
							} else {
								return null;
							}
						},
					},
				},
				plotOptions: {
					series: {
						stacking: "normal",
					},
				},
				series: [
					{
						name: "",
						data: res?.ordersByYearAndMonth.map((p) => p.totalUnits),
						lineWidth: 2,
						lineColor: COLORS.Secondary,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Primary,
							symbol: "circle",
							radius: 3,
						},
						zoneAxis: "x",
						zones: [
							{
								value:
									res?.ordersByYearAndMonth[res.ordersByYearAndMonth.length - 1]
										?.saleMonth === res.generalInfo.actualMonth
										? res?.ordersByYearAndMonth.length - 2
										: res?.ordersByYearAndMonth.length,
								color: COLORS.Secondary,
							},
							{
								color: COLORS.LightSecondary,
							},
						],
					},
				],
			});

			let categories = [];
			let saleSeries = [];
			let unitSeries = [];

			const allDates = res?.categoriesByYearAndMonth
				?.map(
					({ saleYear, saleMonth }) =>
						`${saleYear}-${String(saleMonth).padStart(2, "0")}`
				)
				?.sort();

			const uniqueDates = [...new Set(allDates)];

			let saleDataByCategory = res?.categorySales
				?.map((d) => d.categoryName)
				?.reduce((acc, name) => {
					acc[name] = uniqueDates.map(() => 0);
					return acc;
				}, {});

			let unitDataByCategory = res?.categorySales
				?.map((d) => d.categoryName)
				?.reduce((acc, name) => {
					acc[name] = uniqueDates.map(() => 0);
					return acc;
				}, {});

			res?.categoriesByYearAndMonth?.forEach(
				({ saleYear, saleMonth, totalSales, totalUnits, categoryNameList }) => {
					if (saleDataByCategory[categoryNameList]) {
						const date = `${saleYear}-${String(saleMonth).padStart(2, "0")}`;
						const index = uniqueDates.indexOf(date);
						if (index !== -1) {
							saleDataByCategory[categoryNameList][index] = totalSales;
							unitDataByCategory[categoryNameList][index] = totalUnits;
						}
					}
				}
			);

			categories = uniqueDates;
			saleSeries = Object.keys(saleDataByCategory)?.map((name, index) => ({
				name,
				data: saleDataByCategory[name],
				lineColor: COLORS.ChartColors[index],
				color: COLORS.ChartColors[index],
				lineWidth: 2,
				marker: {
					fillColor: "white",
					lineWidth: 2,
					lineColor: COLORS.ChartColors[index],
					symbol: "circle",
					radius: 3,
				},
			}));

			unitSeries = Object.keys(unitDataByCategory)?.map((name, index) => ({
				name,
				data: unitDataByCategory[name],
				lineColor: COLORS.ChartColors[index],
				color: COLORS.ChartColors[index],
				lineWidth: 2,
				marker: {
					fillColor: "white",
					lineWidth: 2,
					lineColor: COLORS.ChartColors[index],
					symbol: "circle",
					radius: 3,
				},
			}));

			setTimeCategoriesSalesGraphD2({
				chart: { type: "column", zoomType: "x" },
				title: { text: undefined },
				credits: { enabled: false },
				xAxis: { categories: categories, min: 0 },
				yAxis: {
					title: { text: "Total ventas" },
					stackLabels: {
						enabled: true,
						style: {
							color: COLORS.MediumGrey,
							textOutline: 0,
						},
					},
					gridLineColor: COLORS.LightGrey,
					gridLineWidth: 1,
					lineWidth: 1,
					plotLines: [
						{
							color: "#FF0000",
							width: 1,
							value: 0,
						},
					],
				},
				tooltip: {
					shared: false,
					useHTML: true,
					formatter: function () {
						return `<span style="color:${this.point.color}">\u25CF</span> ${
							this.series.name
						}: $${numberWithDotAndCommas(this.point.y)}<br/><b>(${(
							(this.point.y * 100) /
							this.point.stackTotal
						).toFixed(2)} %)</b><br/>`;
					},
				},
				plotLines: [
					{
						color: "#FF0000",
						width: 1,
						value: 0,
					},
				],
				plotOptions: {
					column: {
						stacking: "normal",
						dataLabels: {
							enabled: true,
							style: {
								fontWeight: "lighter",
								color: COLORS.White,
								fontSize: "8px",
								textOutline: 1,
							},
							formatter: function () {
								const percentage = (
									(this.point.y * 100) /
									this.point.stackTotal
								).toFixed(2);
								return percentage > 10 ? `${percentage}%` : null;
							},
							verticalAlign: "middle",
							inside: true,
							crop: true,
						},
					},
					series: {
						states: {
							hover: {
								enabled: true,
							},
						},
						marker: {
							enabled: true,
						},
					},
				},
				series: saleSeries,
			});

			setTimeCategoriesUnitsGraphD2({
				chart: { type: "column", zoomType: "x" },
				title: { text: undefined },
				credits: { enabled: false },
				xAxis: { categories: categories, min: 0 },
				yAxis: {
					title: { text: "Total ventas" },
					stackLabels: {
						enabled: true,
						style: {
							color: COLORS.MediumGrey,
							textOutline: 0,
						},
					},
					gridLineColor: COLORS.LightGrey,
					gridLineWidth: 1,
					lineWidth: 1,
					plotLines: [
						{
							color: "#FF0000",
							width: 1,
							value: 0,
						},
					],
				},
				tooltip: {
					shared: false,
					useHTML: true,
					formatter: function () {
						return `<span style="color:${this.point.color}">\u25CF</span> ${
							this.series.name
						}: ${this.point.y}<br/><b>(${(
							(this.point.y * 100) /
							this.point.stackTotal
						).toFixed(2)} %)</b><br/>`;
					},
				},
				plotLines: [
					{
						color: "#FF0000",
						width: 1,
						value: 0,
					},
				],
				plotOptions: {
					column: {
						stacking: "normal",
						dataLabels: {
							enabled: true,
							style: {
								fontWeight: "lighter",
								color: COLORS.White,
								fontSize: "8px",
								textOutline: 1,
							},
							formatter: function () {
								const percentage = (
									(this.point.y * 100) /
									this.point.stackTotal
								).toFixed(2);
								return percentage > 10 ? `${percentage}%` : null;
							},
							verticalAlign: "middle",
							inside: true,
							crop: true,
						},
					},
					series: {
						states: {
							hover: {
								enabled: true,
							},
						},
						marker: {
							enabled: true,
						},
					},
				},
				series: unitSeries,
			});

			setTimeHistoricSalesGraphD2({
				chart: { type: "xy" },
				title: {
					text: undefined,
				},
				tooltip: {
					shared: true,
					pointFormat:
						'<span style="color:{series.color}">{series.name}<b> {point.y}</b></span><br/>',
					valueDecimals: 0,
					split: false,
				},
				legend: {
					enabled: false,
				},
				colors: [COLORS.Secondary, COLORS.Primary],
				credits: { enabled: false },
				xAxis: {
					categories: res?.ordersByYearAndMonth.map(
						(p) => CONSTANTS.CALENDAR_MONTHS[p.saleMonth]
					),
				},
				yAxis: [
					{
						labels: {
							formatter: function () {
								return this.value === 0
									? 0
									: (this.value / 1000000).toFixed(2) + "M";
							},
							style: {
								color: COLORS.Primary,
							},
						},
						visible: true,
						title: {
							text: "Ventas",
							style: {
								color: COLORS.Primary,
							},
						},
						gridLineColor: COLORS.LightGrey,
						gridLineWidth: 1,
						lineWidth: 1,
						plotLines: [
							{
								color: "#FF0000",
								width: 1,
								value: 0,
							},
						],
						stackLabels: {
							enabled: true,
							style: {
								color: COLORS.MediumGrey,
								textOutline: 0,
							},
							y: -2,
							overflow: "allow",
							crop: false,
							formatter: function () {
								return numberToMillions(this.total);
							},
						},
					},
					{
						title: {
							text: "Unidades",
							style: {
								color: COLORS.Secondary,
							},
						},
						visible: true,
						labels: {
							style: {
								color: COLORS.Secondary,
							},
						},
						opposite: true,
						gridLineColor: "#197F07",
						gridLineWidth: 0,
						lineWidth: 1,
						plotLines: [
							{
								color: "#FF0000",
								width: 1,
								value: 0,
							},
						],
					},
				],
				plotOptions: {
					series: {
						stacking: "normal",
					},
				},
				series: [
					{
						name: "Unidades",
						type: "column",
						valueSuffix: "un.",
						data: res?.ordersByYearAndMonth.map((p) => p.totalUnits),
						yAxis: 1,
						lineWidth: 2,
						lineColor: COLORS.Default,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Default,
							symbol: "circle",
							radius: 3,
						},
						zoneAxis: "x",
						zones: [
							{
								value:
									res?.ordersByYearAndMonth[res.ordersByYearAndMonth.length - 1]
										?.saleMonth === res.generalInfo.actualMonth
										? res?.ordersByYearAndMonth.length - 1
										: res?.ordersByYearAndMonth.length,
								color: COLORS.Secondary,
							},
							{
								color: COLORS.LightSecondary,
							},
						],
					},
					{
						name: "Ventas $",
						type: "spline",
						valuePrefix: "$",
						data: res?.ordersByYearAndMonth.map((p) => p.totalSales),
						yAxis: 0,
						lineWidth: 2,
						lineColor: COLORS.Primary,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Primary,
							symbol: "circle",
							radius: 3,
						},
						zoneAxis: "x",
						zones: [
							{
								value:
									res?.ordersByYearAndMonth[res.ordersByYearAndMonth.length - 1]
										?.saleMonth === res.generalInfo.actualMonth
										? res?.ordersByYearAndMonth.length - 2
										: res?.ordersByYearAndMonth.length,
								color: COLORS.Primary,
							},
							{
								color: COLORS.LightSecondary,
							},
						],
					},
				],
			});
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const fetch_mobile_dashboard = async () => {
		setIsLoading(true);
		try {
			const res = await get_dinamic_mobile_dashboard(
				selectedDistributor,
				clientId,
				selectedSellerList,
				dateFromD3,
				dateToD3,
				selectedCategory
			);
			const resDistributorsD3 = JSON.parse(res?.generalInfo?.distributorList);
			const resSellersD3 = JSON.parse(res?.generalInfo?.sellerList);
			const resCategoriesD3 = JSON.parse(res?.generalInfo?.categoryList);

			setDistributorsD3(
				resDistributorsD3?.map((r) => ({
					value: r.DistributorId,
					label: r.DistributorName,
				}))
			);

			setUsersD3(
				resSellersD3?.map((r) => ({
					value: r.SellerId,
					label: r.SellerFirstName + " " + r.SellerLastName,
				}))
			);

			setCategoriesD3(
				resCategoriesD3?.map((r) => ({
					value: r.Id,
					label: r.Name,
				}))
			);

			setGeneralInfoD3(res?.generalInfo);

			setTimePharmacyOrdersGraphD3({
				chart: { type: "spline" },
				title: {
					text: undefined,
				},
				tooltip: {
					shared: true,
					formatter: function () {
						return "<b>" + this.x + "</b></br>" + this.y;
					},
				},
				legend: {
					enabled: false,
				},
				colors: [COLORS.Default, COLORS.Grey],
				credits: { enabled: false },
				xAxis: {
					categories: res?.posOrderingByYearAndMonth.map(
						(p) => CONSTANTS.CALENDAR_MONTHS[p.saleMonth]
					),
				},
				yAxis: {
					visible: true,
					title: {
						text: null,
					},
					labels: {
						enabled: true,
					},
					gridLineColor: "#197F07",
					gridLineWidth: 0,
					lineWidth: 1,
					plotLines: [
						{
							color: "#FF0000",
							width: 1,
							value: 0,
						},
					],
					stackLabels: {
						enabled: true,
						style: {
							color: COLORS.MediumGrey,
							textOutline: 0,
						},
						y: -8,
						overflow: "allow",
						crop: false,
						formatter: function () {
							if (
								this.x ===
									this.axis.series[0]?.xData[
										this.axis.series[0]?.xData.length - 2
									] &&
								this.axis.series[0]?.data[this.axis.series[0]?.data.length - 1]
									?.category ===
									CONSTANTS.CALENDAR_MONTHS[res.generalInfo.actualMonth]
							) {
								return numberToMillions(this.total);
							} else {
								return null;
							}
						},
					},
				},
				plotOptions: {
					series: {
						stacking: "normal",
					},
				},
				series: [
					{
						name: "",
						data: res?.posOrderingByYearAndMonth.map((p) => p.totalPosOrdering),
						lineWidth: 2,
						lineColor: COLORS.Success,
						marker: {
							fillColor: COLORS.Secondary,
							lineWidth: 2,
							lineColor: COLORS.Secondary,
							symbol: "circle",
							radius: 3,
						},
						zoneAxis: "x",
						zones: [
							{
								value:
									res?.posOrderingByYearAndMonth[
										res.posOrderingByYearAndMonth.length - 1
									]?.saleMonth === res.generalInfo.actualMonth
										? res?.posOrderingByYearAndMonth.length - 2
										: res?.posOrderingByYearAndMonth.length,
								color: COLORS.Success,
							},
							{
								color: COLORS.LightSuccess,
							},
						],
					},
				],
			});

			setSellerSalesTableD3(res?.sellerSales);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const fetch_pharmacy_dashboard = async () => {
		setIsLoading(true);
		try {
			const res = await get_pharmacy_laboratory_dashboard(
				selectedDistributor,
				clientId,
				selectedPharmacy,
				dateFromD4,
				dateToD4,
				selectedChain,
				selectedSellerList,
				selectedCategory
			);
			const resDistributorsD4 = JSON.parse(res?.generalInfo?.distributorList);
			const resPharmaciesD4 = JSON.parse(res?.generalInfo?.pharmacyList);
			const slicedPharmacyTable = res?.pharmacyOrdersList.slice(0, 50);
			const resChainsD4 = JSON.parse(res?.generalInfo?.chainList);
			const resUsersD4 = JSON.parse(res?.generalInfo?.sellerList);
			const resCategoriesD4 = JSON.parse(res?.generalInfo?.categoryList);

			setDistributorsD4(
				resDistributorsD4?.map((r) => ({
					value: r.DistributorId,
					label: r.DistributorName,
				}))
			);

			setPharmaciesD4(
				resPharmaciesD4?.map((r) => ({
					value: r.PharmacyId,
					label: r.PharmacyName,
				}))
			);

			setChainsD4(
				resChainsD4?.map((r) => ({
					value: r.ChainId,
					label: r.ChainName,
				}))
			);

			setUsersD4(
				resUsersD4?.map((r) => ({
					value: r.SellerId,
					label: r.SellerFirstName + " " + r.SellerLastName,
				}))
			);

			setCategoriesD4(
				resCategoriesD4?.map((r) => ({
					value: r.Id,
					label: r.Name,
				}))
			);

			setGeneralInfoD4(res?.generalInfo);

			setPharmaciesTable(slicedPharmacyTable);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const fetch_product_dashboard = async () => {
		setIsLoading(true);
		try {
			const res = await get_products_laboratory_dashboard(
				selectedDistributor,
				clientId,
				dateFromD5,
				dateToD5,
				selectedBrand,
				selectedCategory,
				selectedChain,
				selectedSellerList
			);
			const resDistributorsD5 = JSON.parse(res?.generalInfo?.distributorList);
			const resBrandsD5 = JSON.parse(res?.generalInfo?.brandList);
			const resCategoriesD5 = JSON.parse(res?.generalInfo?.categoryList);
			const resChainsD5 = JSON.parse(res?.generalInfo?.chainList);
			const slicedProductTable = res?.productOrdersList;
			const resSellersD5 = JSON.parse(res?.generalInfo?.sellerList);

			setDistributorsD5(
				resDistributorsD5?.map((r) => ({
					value: r.DistributorId,
					label: r.DistributorName,
				}))
			);

			setBrandsD5(
				resBrandsD5?.map((r) => ({
					value: r.BrandId,
					label: r.BrandName,
				}))
			);

			setCategoriesD5(
				resCategoriesD5?.map((r) => ({
					value: r.Id,
					label: r.Name,
				}))
			);

			setChainsD5(
				resChainsD5?.map((r) => ({
					value: r.ChainId,
					label: r.ChainName,
				}))
			);

			setUsersD5(
				resSellersD5?.map((r) => ({
					value: r.SellerId,
					label: r.SellerFirstName + " " + r.SellerLastName,
				}))
			);

			setGeneralInfoD5(res?.generalInfo);

			setProductsTable(slicedProductTable);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const fetch_initiative_dashboard = async () => {
		setIsLoading(true);
		try {
			const res = await get_initiatives_dashboard(
				selectedDistributor,
				clientId,
				dateFromD6,
				dateToD6,
				selectedCategory,
				selectedChain,
				selectedSellerList,
				selectedInitiative
			);
			const resDistributorsD6 = JSON.parse(res?.generalInfo?.distributorList);
			const resCategoriesD6 = JSON.parse(res?.generalInfo?.categoryList);
			const resChainsD6 = JSON.parse(res?.generalInfo?.chainList);
			const resSellersD6 = JSON.parse(res?.generalInfo?.sellerList);
			const resInitiativesD6 = JSON.parse(res?.generalInfo?.initiativeList);

			setDistributorsD6(
				resDistributorsD6?.map((r) => ({
					value: r.DistributorId,
					label: r.DistributorName,
				}))
			);

			setCategoriesD6(
				resCategoriesD6?.map((r) => ({
					value: r.Id,
					label: r.Name,
				}))
			);

			setChainsD6(
				resChainsD6?.map((r) => ({
					value: r.ChainId,
					label: r.ChainName,
				}))
			);

			setUsersD6(
				resSellersD6?.map((r) => ({
					value: r.SellerId,
					label: r.SellerFirstName + " " + r.SellerLastName,
				}))
			);

			setInitiativesD6(
				resInitiativesD6?.map((r) => ({
					value: r.Id,
					label: r.Title,
				}))
			);

			setGeneralInfoD6(res?.generalInfo);

			setProductTotalvsInitiativesD6({
				chart: { zoomType: "xy" },
				title: {
					text: undefined,
				},
				tooltip: {
					shared: true,
					pointFormat:
						'<span style="color:{series.color}">{series.name}:  <b>$ {point.y}</b></span><br/>' +
						'<span style="color:{series.color}">Porcentaje sobre Ventas Totales:  <b>{point.percentage}%</b></span><br/>',
					valueDecimals: 0,
					split: false,
					formatter: function () {
						const totalPeriod = res?.generalInfo?.totalYearSales;
						const initiativeValue = this.points[0].y;

						const percentage =
							totalPeriod === 0 ? 0 : (initiativeValue / totalPeriod) * 100;

						return `<span style="color:${this.points[1].series.color}">&nbsp${
							this.points[0].series.name
						}: <b>$${numberWithDotAndCommas(
							parseFloat(initiativeValue)
						)}</b></span>
              <br/>
              <span style="color:${
								COLORS.Default
							}">Porcentaje sobre Ventas Período: <b>${percentage.toFixed(
							2
						)}%</b></span><br/>
            `;
					},
				},
				legend: {
					enabled: false,
				},
				colors: [COLORS.Secondary, COLORS.Secondary],
				credits: { enabled: false },
				xAxis: {
					categories: res?.productSales?.map(
						(d) => d.productTitle + " (" + d.productEan13 + ")"
					),
				},
				yAxis: [
					{
						labels: {
							formatter: function () {
								return this.value === 0
									? 0
									: (this.value / 1000000).toFixed(2) + "M";
							},
							style: {
								color: COLORS.Secondary,
							},
						},
						visible: true,
						title: {
							text: "Ventas",
							style: {
								color: COLORS.Secondary,
							},
						},
						gridLineColor: COLORS.LightGrey,
						gridLineWidth: 1,
						lineWidth: 1,
						plotLines: [
							{
								color: "#FF0000",
								width: 1,
								value: 0,
							},
						],
						stackLabels: {
							enabled: true,
							style: {
								color: COLORS.MediumGrey,
								textOutline: 0,
							},
							y: -2,
							overflow: "allow",
							crop: false,
							formatter: function () {
								return numberToMillions(this.total);
							},
						},
					},
					{
						title: {
							text: "",
							style: {
								color: COLORS.White,
							},
						},
						min: 0.0,
						max: 100.0,
						visible: true,
						labels: {
							style: {
								color: COLORS.White,
							},
						},
						opposite: true,
						gridLineColor: "#197F07",
						gridLineWidth: 0,
						lineWidth: 1,
						plotLines: [
							{
								color: "#FF0000",
								width: 1,
								value: 0,
							},
						],
						stackLabels: {
							enabled: true,
							style: {
								color: COLORS.Default,
								textOutline: 0,
							},
							y: -2,
							overflow: "allow",
							crop: false,
							formatter: function () {
								return "%" + this.total.toFixed(2);
							},
						},
					},
				],
				plotOptions: {
					series: {
						stacking: "normal",
					},
				},
				series: [
					{
						name: "Iniciativa",
						type: "column",
						valuePrefix: "$",
						data: res?.productSales?.map((d) => d.totalInOrderWithInitiative),
						yAxis: 0,
						lineWidth: 2,
						lineColor: COLORS.Secondary,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Secondary,
							symbol: "circle",
							radius: 3,
						},
					},
					{
						name: "Porcentaje",
						type: "spline",
						valuePrefix: "%",
						data: res?.productSales?.map((d) =>
							res?.generalInfo?.totalYearSales === 0
								? 0
								: (d.totalInOrderWithInitiative /
										res?.generalInfo?.totalYearSales) *
								  100
						),
						yAxis: 1,
						lineWidth: 2,
						lineColor: COLORS.Default,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Default,
							symbol: "circle",
							radius: 3,
						},
						// zoneAxis: "x",
						// zones: [
						// 	{
						// 		color: COLORS.Default,
						// 	},
						// 	{
						// 		color: COLORS.LightDefault,
						// 	},
						// ],
					},
				],
			});

			setTimeInitiativesSalesGraphD6({
				chart: { zoomType: "xy" },
				title: {
					text: undefined,
				},
				tooltip: {
					shared: true,
					pointFormat:
						'<span style="color:{series.color}">{series.name}:  <b>$ {point.y}</b></span><br/>' +
						'<span style="color:{series.color}">Porcentaje sobre Ventas Totales:  <b>{point.percentage}%</b></span><br/>',
					valueDecimals: 0,
					split: false,
					formatter: function () {
						const totalSalesPoint = this.points.find(
							(p) => p.series.name === "Ventas Totales"
						);
						const initiativePoint = this.points.find(
							(p) => p.series.name === "Iniciativas"
						);

						if (totalSalesPoint && initiativePoint) {
							const totalSalesValue = this.points[0].y;
							const initiativeValue = this.points[1].y;

							const percentage =
								totalSalesValue === 0
									? 0
									: (initiativeValue / totalSalesValue) * 100;

							return `<span style="color:${this.points[0].series.color}">&nbsp${
								this.points[0].series.name
							}: <b>$${numberWithDotAndCommas(
								parseFloat(totalSalesValue)
							)}</b></span><br/><span style="color:${
								this.points[1].series.color
							}"> ${this.points[1].series.name}: <b>$${numberWithDotAndCommas(
								parseFloat(initiativeValue)
							)}</b></span>
                    <br/>
                    <span style="color:${
											COLORS.Default
										}">Porcentaje sobre Ventas Totales: <b>${percentage.toFixed(
								2
							)}%</b></span><br/>
                  `;
						} else {
							const point = this.points[0];
							return `
                  <span style="color:${point.series.color}">${
								point.series.name
							}: <b>$ ${numberWithDotAndCommas(
								parseFloat(point.y)
							)}</b></span><br/>
                `;
						}
					},
				},
				legend: {
					enabled: true,
				},
				colors: [COLORS.Secondary, COLORS.Primary],
				credits: { enabled: false },
				xAxis: {
					categories: res?.ordersByYearAndMonth.map(
						(p) => CONSTANTS.CALENDAR_MONTHS[p.saleMonth]
					),
				},
				yAxis: [
					{
						labels: {
							formatter: function () {
								return this.value === 0
									? 0
									: (this.value / 1000000).toFixed(2) + "M";
							},
							style: {
								color: COLORS.Secondary,
							},
						},
						visible: true,
						title: {
							text: "Ventas",
							style: {
								color: COLORS.Secondary,
							},
						},
						gridLineColor: COLORS.LightGrey,
						gridLineWidth: 1,
						lineWidth: 1,
						plotLines: [
							{
								color: "#FF0000",
								width: 1,
								value: 0,
							},
						],
						// stackLabels: {
						// 	enabled: true,
						// 	style: {
						// 		color: COLORS.MediumGrey,
						// 		textOutline: 0,
						// 	},
						// 	y: -2,
						// 	overflow: "allow",
						// 	crop: false,
						// 	formatter: function () {
						// 		return numberToMillions(this.total);
						// 	},
						// },
					},
					{
						title: {
							text: "Iniciativas",
							style: {
								color: COLORS.Secondary,
							},
						},
						visible: false,
						labels: {
							style: {
								color: COLORS.Secondary,
							},
						},
						opposite: true,
						gridLineColor: "#197F07",
						gridLineWidth: 0,
						lineWidth: 1,
						plotLines: [
							{
								color: "#FF0000",
								width: 1,
								value: 0,
							},
						],
					},
				],
				plotOptions: {
					series: {
						stacking: "normal",
					},
				},
				series: [
					{
						name: "Ventas Totales",
						type: "spline",
						valuePrefix: "$",
						data: res?.ordersByYearAndMonth.map(
							(d) => d.totalSalesWithoutInitiative
						),
						yAxis: 0,
						lineWidth: 2,
						lineColor: COLORS.Secondary,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Secondary,
							symbol: "circle",
							radius: 3,
						},
					},
					{
						name: "Iniciativas",
						type: "spline",
						valuePrefix: "$",
						data: res?.ordersByYearAndMonth?.map(
							(d) => d.totalSalesWithInitiative
						),
						yAxis: 0,
						lineWidth: 2,
						lineColor: COLORS.Primary,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Primary,
							symbol: "circle",
							radius: 3,
						},
					},
				],
			});

			setTimeInitiativesUnitsGraphD6({
				chart: { zoomType: "xy" },
				title: {
					text: undefined,
				},
				tooltip: {
					shared: true,
					pointFormat:
						'<span style="color:{series.color}">{series.name}:  <b>{point.y}</b></span><br/>' +
						'<span style="color:{series.color}">Porcentaje sobre Unidades Totales:  <b>{point.percentage}%</b></span><br/>',
					valueDecimals: 0,
					split: false,
					formatter: function () {
						const totalUnitsPoint = this.points.find(
							(p) => p.series.name === "Unidades Totales"
						);
						const initiativePoint = this.points.find(
							(p) => p.series.name === "Iniciativas"
						);

						if (totalUnitsPoint && initiativePoint) {
							const totalUnitsValue = this.points[0].y;
							const initiativeValue = this.points[1].y;

							const percentage =
								totalUnitsValue === 0
									? 0
									: (initiativeValue / totalUnitsValue) * 100;

							return `<span style="color:${this.points[0].series.color}">&nbsp${
								this.points[0].series.name
							}: <b>${totalUnitsValue}</b></span><br/><span style="color:${
								this.points[1].series.color
							}"> ${
								this.points[1].series.name
							}: <b>${initiativeValue}</b></span>
                    <br/>
                    <span style="color:${
											COLORS.Default
										}">Porcentaje sobre Ventas Totales: <b>${percentage.toFixed(
								2
							)}%</b></span><br/>
                  `;
						} else {
							const point = this.points[0];
							return `
                  <span style="color:${point.series.color}">${point.series.name}: <b>$ ${point.y}</b></span><br/>
                `;
						}
					},
				},
				legend: {
					enabled: true,
				},
				colors: [COLORS.Secondary, COLORS.Primary],
				credits: { enabled: false },
				xAxis: {
					categories: res?.ordersByYearAndMonth.map(
						(p) => CONSTANTS.CALENDAR_MONTHS[p.saleMonth]
					),
				},
				yAxis: [
					{
						labels: {
							formatter: function () {
								return this.value === 0 ? 0 : this.value;
							},
							style: {
								color: COLORS.Secondary,
							},
						},
						visible: true,
						title: {
							text: "Unidades",
							style: {
								color: COLORS.Secondary,
							},
						},
						gridLineColor: COLORS.LightGrey,
						gridLineWidth: 1,
						lineWidth: 1,
						plotLines: [
							{
								color: "#FF0000",
								width: 1,
								value: 0,
							},
						],
						// stackLabels: {
						// 	enabled: true,
						// 	style: {
						// 		color: COLORS.MediumGrey,
						// 		textOutline: 0,
						// 	},
						// 	y: -2,
						// 	overflow: "allow",
						// 	crop: false,
						// 	formatter: function () {
						// 		return this.total;
						// 	},
						// },
					},
					{
						title: {
							text: "Iniciativas",
							style: {
								color: COLORS.Secondary,
							},
						},
						visible: false,
						labels: {
							style: {
								color: COLORS.Secondary,
							},
						},
						opposite: true,
						gridLineColor: "#197F07",
						gridLineWidth: 0,
						lineWidth: 1,
						plotLines: [
							{
								color: "#FF0000",
								width: 1,
								value: 0,
							},
						],
					},
				],
				plotOptions: {
					series: {
						stacking: "normal",
					},
				},
				series: [
					{
						name: "Unidades Totales",
						type: "spline",
						valuePrefix: "$",
						data: res?.ordersByYearAndMonth.map(
							(d) => d.totalUnitsWithoutInitiative
						),
						yAxis: 0,
						lineWidth: 2,
						lineColor: COLORS.Secondary,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Secondary,
							symbol: "circle",
							radius: 3,
						},
					},
					{
						name: "Iniciativas",
						type: "spline",
						valuePrefix: "$",
						data: res?.ordersByYearAndMonth?.map(
							(d) => d.totalUnitsWithInitiative
						),
						yAxis: 0,
						lineWidth: 2,
						lineColor: COLORS.Primary,
						marker: {
							fillColor: COLORS.White,
							lineWidth: 2,
							lineColor: COLORS.Primary,
							symbol: "circle",
							radius: 3,
						},
					},
				],
			});
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const fetch_chain_dashboard = async () => {
		setIsLoading(true);
		try {
			const res = await get_chain_laboratory_dashboard(
				selectedDistributor,
				clientId,
				dateFromD7,
				dateToD7,
				selectedChain,
				selectedSellerList,
				selectedCategory
			);
			const resDistributorsD7 = JSON.parse(res?.generalInfo?.distributorList);
			const slicedChainTable = res?.chainOrdersList?.map((c) => ({
				...c,
				sellerList: (c.sellerFirstName?.split(",") || []).map(
					(firstName, index) =>
						`${firstName} ${(c.sellerLastName?.split(",") || [])[index] || ""}`
				),
			}));
			const resChainsD7 = JSON.parse(res?.generalInfo?.chainList);
			const resUsersD7 = JSON.parse(res?.generalInfo?.sellerList);
			const resCategoriesD7 = JSON.parse(res?.generalInfo?.categoryList);

			setDistributorsD7(
				resDistributorsD7?.map((r) => ({
					value: r.DistributorId,
					label: r.DistributorName,
				}))
			);

			setChainsD7(
				resChainsD7?.map((r) => ({
					value: r.ChainId,
					label: r.ChainName,
				}))
			);

			setUsersD7(
				resUsersD7?.map((r) => ({
					value: r.SellerId,
					label: r.SellerFirstName + " " + r.SellerLastName,
				}))
			);

			setCategoriesD7(
				resCategoriesD7?.map((r) => ({
					value: r.Id,
					label: r.Name,
				}))
			);

			setGeneralInfoD7(res?.generalInfo);

			setChainsTable(slicedChainTable);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (sellerDashboardDisplay === CONSTANTS.DASHBOARD_SALES)
			fetch_sales_dashboard();
	}, [sellerDashboardDisplay, applyFilters]);

	useEffect(() => {
		if (sellerDashboardDisplay === CONSTANTS.DASHBOARD_MOBILE)
			fetch_mobile_dashboard();
	}, [sellerDashboardDisplay, applyFilters]);

	useEffect(() => {
		if (sellerDashboardDisplay === CONSTANTS.DASHBOARD_PHARMACY)
			fetch_pharmacy_dashboard();
	}, [sellerDashboardDisplay, applyFilters]);

	useEffect(() => {
		if (sellerDashboardDisplay === CONSTANTS.DASHBOARD_PRODUCTS)
			fetch_product_dashboard();
	}, [sellerDashboardDisplay, applyFilters]);

	useEffect(() => {
		if (sellerDashboardDisplay === CONSTANTS.DASHBOARD_INITIATIVES)
			fetch_initiative_dashboard();
	}, [sellerDashboardDisplay, applyFilters]);

	useEffect(() => {
		if (sellerDashboardDisplay === CONSTANTS.DASHBOARD_CHAIN)
			fetch_chain_dashboard();
	}, [sellerDashboardDisplay, applyFilters]);
	// const handleBackToTheGuide = () => {
	// 	updateStartGuideProgress(user.uid, 6);
	// 	navigate("/startGuide");
	// };

	const upsertFilter = (label, key) => {
		setSelectedFilters((prevFilters) => {
			const filtered = prevFilters.filter((filter) => filter.key !== key);
			return [...filtered, { label, key }];
		});
	};

	const handleSelectDistributor = (e, o) => {
		setSelectedDistributor(e);
		upsertFilter(o?.label, "Distributor");
	};

	const handleSelectCategory = (e, o) => {
		setSelectedCategory(e);
		upsertFilter(o?.label, "Category");
	};

	const handleSelectChain = (e, o) => {
		setSelectedChain(e);
		upsertFilter(o?.label, "Chain");
	};

	const handleSelectBrand = (e, o) => {
		setSelectedBrand(e);
		upsertFilter(o?.label, "Brand");
	};

	const handleSelectInitiative = (e, o) => {
		setSelectedInitiative(e);
		upsertFilter(o?.label, "Initiative");
	};

	const handleDeleteFilters = () => {
		setSelectedDistributor(null);
		setSelectedPharmacy(null);
		setSelectedSellerList(
			userdata.isOneMarket ||
				(userdata.isSeller &&
					(userdata.isAdmin ||
						(!userdata.p_shop && !userdata.p_mobile && userdata.dashboard)))
				? []
				: user.uid
		);
		setSelectedCategory(null);
		setSelectedChain(null);
		setSelectedBrand(null);
		setSelectedInitiative(null);
		setDateFrom(moment().startOf("month").format("MM-DD-YYYY").toString());
		setDateTo(moment().endOf("month").format("MM-DD-YYYY").toString());
		setRangeDate([moment().startOf("month"), moment().endOf("month")]);
		setSelectedFilters([]);
		setMobilePeriod(CONSTANTS.PERIOD_CURRENT);
		setDateFromD3(moment().startOf("month").format("MM-DD-YYYY").toString());
		setDateToD3(moment().endOf("month").format("MM-DD-YYYY").toString());
		setRangeDateD3([moment().startOf("month"), moment().endOf("month")]);
		setSalesPeriod(CONSTANTS.PERIOD_CURRENT);
		setDateFromD2(moment().startOf("month").format("MM-DD-YYYY").toString());
		setDateToD2(moment().endOf("month").format("MM-DD-YYYY").toString());
		setRangeDateD2([moment().startOf("month"), moment().endOf("month")]);
		setChainsPeriod(CONSTANTS.PERIOD_CURRENT);
		setDateFromD4(moment().startOf("month").format("MM-DD-YYYY").toString());
		setDateToD4(moment().endOf("month").format("MM-DD-YYYY").toString());
		setRangeDateD4([moment().startOf("month"), moment().endOf("month")]);
		setPharmaciesPeriod(CONSTANTS.PERIOD_CURRENT);
		setDateFromD5(moment().startOf("month").format("MM-DD-YYYY").toString());
		setDateToD5(moment().endOf("month").format("MM-DD-YYYY").toString());
		setRangeDateD5([moment().startOf("month"), moment().endOf("month")]);
		setProductsPeriod(CONSTANTS.PERIOD_CURRENT);
		setDateFromD6(moment().startOf("month").format("MM-DD-YYYY").toString());
		setDateToD6(moment().endOf("month").format("MM-DD-YYYY").toString());
		setRangeDateD6([moment().startOf("month"), moment().endOf("month")]);
		setInitiativesPeriod(CONSTANTS.PERIOD_CURRENT);
		setDateFromD7(moment().startOf("month").format("MM-DD-YYYY").toString());
		setDateToD7(moment().endOf("month").format("MM-DD-YYYY").toString());
		setRangeDateD7([moment().startOf("month"), moment().endOf("month")]);
		setSelectedTypeOfSale(null);
		setApplyFilters((prev) => !prev);
		onCloseFilterList();
	};

	const handleSelectSeller = (object) => {
		const sellersValue = object?.map((o) => o.value)?.join(",") ?? [];
		const sellersLabel = object?.map((o) => o.label)?.join(",") ?? null;
		setSelectedSellerList(sellersValue);
		sellersLabel && upsertFilter(sellersLabel, "Seller");
	};

	const handleSelectPharmacy = (e, o) => {
		setSelectedPharmacy(e);
		upsertFilter(o?.label, "Pharmacy");
	};

	const handleSelectedDateD3 = (dateRange) => {
		const firstDate = moment(dateRange[0]).format("MM-DD-YYYY").toString();
		const lastDate = moment(dateRange[1]).format("MM-DD-YYYY").toString();
		setDateFromD3(firstDate);
		setDateToD3(lastDate);
		setDateFrom(firstDate);
		setDateTo(lastDate);
		setRangeDate([dateRange[0], dateRange[1]]);
	};

	const handleSelectedDateD2 = (dateRange) => {
		const firstDate = moment(dateRange[0]).format("MM-DD-YYYY").toString();
		const lastDate = moment(dateRange[1]).format("MM-DD-YYYY").toString();
		setDateFromD2(firstDate);
		setDateToD2(lastDate);
		setRangeDateD2([dateRange[0], dateRange[1]]);
		setDateFrom(firstDate);
		setDateTo(lastDate);
		setRangeDate([dateRange[0], dateRange[1]]);
	};

	const handleSelectedDateD4 = (dateRange) => {
		const firstDate = moment(dateRange[0]).format("MM-DD-YYYY").toString();
		const lastDate = moment(dateRange[1]).format("MM-DD-YYYY").toString();
		setDateFromD4(firstDate);
		setDateToD4(lastDate);
		setRangeDateD4([dateRange[0], dateRange[1]]);
		setDateFrom(firstDate);
		setDateTo(lastDate);
		setRangeDate([dateRange[0], dateRange[1]]);
	};

	const handleSelectedDateD5 = (dateRange) => {
		const firstDate = moment(dateRange[0]).format("MM-DD-YYYY").toString();
		const lastDate = moment(dateRange[1]).format("MM-DD-YYYY").toString();
		setDateFromD5(firstDate);
		setDateToD5(lastDate);
		setRangeDateD5([dateRange[0], dateRange[1]]);
		setDateFrom(firstDate);
		setDateTo(lastDate);
		setRangeDate([dateRange[0], dateRange[1]]);
	};

	const handleSelectedDateD6 = (dateRange) => {
		const firstDate = moment(dateRange[0]).format("MM-DD-YYYY").toString();
		const lastDate = moment(dateRange[1]).format("MM-DD-YYYY").toString();
		setDateFromD6(firstDate);
		setDateToD6(lastDate);
		setRangeDateD6([dateRange[0], dateRange[1]]);
		setDateFrom(firstDate);
		setDateTo(lastDate);
		setRangeDate([dateRange[0], dateRange[1]]);
	};

	const handleSelectedDateD7 = (dateRange) => {
		const firstDate = moment(dateRange[0]).format("MM-DD-YYYY").toString();
		const lastDate = moment(dateRange[1]).format("MM-DD-YYYY").toString();
		setDateFromD7(firstDate);
		setDateToD7(lastDate);
		setRangeDateD7([dateRange[0], dateRange[1]]);
		setDateFrom(firstDate);
		setDateTo(lastDate);
		setRangeDate([dateRange[0], dateRange[1]]);
	};

	const handleCategoryGraphSelect2D2 = (value) => {
		setCategoryGraphSelector2D2(value);
	};

	const handleInitiativeGraphSelectD6 = (value) => {
		setInitiativeGraphSelectorD6(value);
	};

	const handlePeriodChange = (value) => {
		// console.log(value);
		setMobilePeriod(value);
		if (value === CONSTANTS.PERIOD_CURRENT) {
			const startOfMonth = moment()
				.startOf("month")
				.format("MM-DD-YYYY")
				.toString();
			const endOfMonth = moment()
				.endOf("month")
				.format("MM-DD-YYYY")
				.toString();
			setDateFromD3(startOfMonth);
			setDateToD3(endOfMonth);
			setRangeDateD3([moment().startOf("month"), moment().endOf("month")]);
		}

		if (value === CONSTANTS.PERIOD_HISTORICAL) {
			setDateFromD3(dateFrom);
			setDateToD3(dateTo);
			setRangeDateD3(rangeDate);
		}
	};

	const handleSalesPeriodChange = (value) => {
		setSalesPeriod(value);
		if (value === CONSTANTS.PERIOD_CURRENT) {
			const startOfMonth = moment()
				.startOf("month")
				.format("MM-DD-YYYY")
				.toString();
			const endOfMonth = moment()
				.endOf("month")
				.format("MM-DD-YYYY")
				.toString();
			setDateFromD2(startOfMonth);
			setDateToD2(endOfMonth);
			setRangeDateD2([moment().startOf("month"), moment().endOf("month")]);
		}

		if (value === CONSTANTS.PERIOD_HISTORICAL) {
			setDateFromD2(dateFrom);
			setDateToD2(dateTo);
			setRangeDateD2(rangeDate);
		}
	};

	const handlePharmaciesPeriodChange = (value) => {
		setPharmaciesPeriod(value);
		if (value === CONSTANTS.PERIOD_CURRENT) {
			const startOfMonth = moment()
				.startOf("month")
				.format("MM-DD-YYYY")
				.toString();
			const endOfMonth = moment()
				.endOf("month")
				.format("MM-DD-YYYY")
				.toString();
			setDateFromD4(startOfMonth);
			setDateToD4(endOfMonth);
			setRangeDateD4([moment().startOf("month"), moment().endOf("month")]);
		}

		if (value === CONSTANTS.PERIOD_HISTORICAL) {
			setDateFromD4(dateFrom);
			setDateToD4(dateTo);
			setRangeDateD4(rangeDate);
		}
	};

	const handleProductsPeriodChange = (value) => {
		setProductsPeriod(value);
		if (value === CONSTANTS.PERIOD_CURRENT) {
			const startOfMonth = moment()
				.startOf("month")
				.format("MM-DD-YYYY")
				.toString();
			const endOfMonth = moment()
				.endOf("month")
				.format("MM-DD-YYYY")
				.toString();
			setDateFromD5(startOfMonth);
			setDateToD5(endOfMonth);
			setRangeDateD5([moment().startOf("month"), moment().endOf("month")]);
		}

		if (value === CONSTANTS.PERIOD_HISTORICAL) {
			setDateFromD5(dateFrom);
			setDateToD5(dateTo);
			setRangeDateD5(rangeDate);
		}
	};

	const handleInitiativesPeriodChange = (value) => {
		setInitiativesPeriod(value);
		if (value === CONSTANTS.PERIOD_CURRENT) {
			const startOfMonth = moment()
				.startOf("month")
				.format("MM-DD-YYYY")
				.toString();
			const endOfMonth = moment()
				.endOf("month")
				.format("MM-DD-YYYY")
				.toString();
			setDateFromD6(startOfMonth);
			setDateToD6(endOfMonth);
			setRangeDateD6([moment().startOf("month"), moment().endOf("month")]);
		}

		if (value === CONSTANTS.PERIOD_HISTORICAL) {
			setDateFromD6(dateFrom);
			setDateToD6(dateTo);
			setRangeDateD6(rangeDate);
		}
	};

	const handleChainsPeriodChange = (value) => {
		setChainsPeriod(value);
		if (value === CONSTANTS.PERIOD_CURRENT) {
			const startOfMonth = moment()
				.startOf("month")
				.format("MM-DD-YYYY")
				.toString();
			const endOfMonth = moment()
				.endOf("month")
				.format("MM-DD-YYYY")
				.toString();
			setDateFromD7(startOfMonth);
			setDateToD7(endOfMonth);
			setRangeDateD7([moment().startOf("month"), moment().endOf("month")]);
		}

		if (value === CONSTANTS.PERIOD_HISTORICAL) {
			setDateFromD7(dateFrom);
			setDateToD7(dateTo);
			setRangeDateD7(rangeDate);
		}
	};

	const handleMenuClick = ({ key }) => {
		setSellerDashboardDisplay(key);
	};

	const handleFilterRemove = (filterToRemove) => {
		setSelectedFilters((prevFilters) =>
			prevFilters.filter((filter) => filter !== filterToRemove)
		);
		//onCloseFilterList();

		switch (filterToRemove.key) {
			case "Distributor":
				setSelectedDistributor(null);
				break;
			case "DateRange":
				setDateFrom(null);
				setDateTo(null);
				setRangeDate(null);
				break;
			case "Seller":
				setSelectedSellerList([]);
				break;
			case "Pharmacy":
				setSelectedPharmacy(null);
				break;
			case "TypeOfSale":
				setSelectedTypeOfSale(null);
				break;
			case "Category":
				setSelectedCategory(null);
				break;
			case "Chain":
				setSelectedChain(null);
				break;
			case "Brand":
				setSelectedBrand(null);
				break;
			case "Initiative":
				setSelectedInitiative(null);
				break;
			default:
				break;
		}
	};

	const showFilterList = (value) => {
		setOpenFilterList(value);
	};

	const onCloseFilterList = () => {
		setOpenFilterList(false);
	};

	const handleOrdersInfoSelect = (value) => {
		setOrdersInfoSelector(value);
	};

	const handleDistributorsPieInfoSelect = (value) => {
		setDistributorsPieInfoSelector(value);
	};

	const handleSalesInfoSelectD2 = (value) => {
		setSalesInfoSelectorD2(value);
	};

	const handleApplyFilters = () => {
		setApplyFilters((prev) => !prev);
	};

	const handleDownloadProductsTable = async () => {
		setIsLoading(true);
		try {
			const dashboardData = {
				productsToExport: productsTable,
			};
			const res = await export_dashboard_products(dashboardData);
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"ProductsDashboard_" + moment().format("DDMMYYYYhhmmss") + ".xlsx";
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Layout style={{ minHeight: "100vh" }}>
			<Sider
				theme="light"
				trigger={null}
				collapsible
				collapsed={collapsed}
				// onMouseEnter={() => setCollapsed(false)}
				// onMouseLeave={() => setCollapsed(true)}
			>
				<div></div>
				<Menu
					theme="light"
					mode="inline"
					defaultSelectedKeys={[CONSTANTS.DASHBOARD_SALES]}
					style={{ paddingTop: 20 }}
					onClick={handleMenuClick}
				>
					<Tooltip
						placement="right"
						title={"Filtros aplicados"}
						trigger={selectedFilters.length > 0 ? "hover" : ""}
					>
						<FilterContainerButton
							key={CONSTANTS.DASHBOARD_FILTERS}
							onClick={
								selectedFilters.length > 0
									? (prev) => showFilterList((prev) => !prev)
									: null
							}
							conditionFullfilled={selectedFilters.length > 0}
							height={45}
						>
							{selectedFilters.length > 0 ? (
								<FaInfo color={COLORS.Primary} size={16} />
							) : null}
						</FilterContainerButton>{" "}
					</Tooltip>
					{
						//!(!userdata.p_shop && userdata.p_mobile)
						userdata && (
							<Menu.Item
								key={CONSTANTS.DASHBOARD_SALES}
								icon={<BarChartOutlined />}
								onClick={() =>
									setSellerDashboardDisplay(CONSTANTS.DASHBOARD_SALES)
								}
							>
								Ventas
							</Menu.Item>
						)
					}
					{clientUser?.client?.contract &&
						clientUser?.client?.contract?.activeMobileApp &&
						clientUser?.client?.contract?.mobileUsersZoneType ===
							CONSTANTS.USER_ZONE_TYPE_ROUTE && (
							<Menu.Item
								key={CONSTANTS.DASHBOARD_MOBILE}
								icon={<MobileOutlined />}
								onClick={() =>
									setSellerDashboardDisplay(CONSTANTS.DASHBOARD_MOBILE)
								}
							>
								Fuerza de venta
							</Menu.Item>
						)}
					{
						//!(!userdata.p_shop && userdata.p_mobile) && (
						userdata && (
							<Menu.Item
								key={CONSTANTS.DASHBOARD_CHAIN}
								icon={<ClusterOutlined />}
								onClick={() =>
									setSellerDashboardDisplay(CONSTANTS.DASHBOARD_CHAIN)
								}
							>
								Cadenas
							</Menu.Item>
						)
					}
					{
						//!(!userdata.p_shop && userdata.p_mobile) && (
						userdata && (
							<Menu.Item
								key={CONSTANTS.DASHBOARD_PHARMACY}
								icon={<TiPlusOutline />}
								onClick={() =>
									setSellerDashboardDisplay(CONSTANTS.DASHBOARD_PHARMACY)
								}
							>
								Farmacias
							</Menu.Item>
						)
					}
					{
						//!(!userdata.p_shop && userdata.p_mobile) && (
						userdata && (
							<Menu.Item
								key={CONSTANTS.DASHBOARD_PRODUCTS}
								icon={<FaBoxes />}
								onClick={() =>
									setSellerDashboardDisplay(CONSTANTS.DASHBOARD_PRODUCTS)
								}
							>
								Productos
							</Menu.Item>
						)
					}
					{userdata && (
						<Menu.Item
							key={CONSTANTS.DASHBOARD_INITIATIVES}
							icon={<BiTrendingUp />}
							onClick={() =>
								setSellerDashboardDisplay(CONSTANTS.DASHBOARD_INITIATIVES)
							}
						>
							Iniciativas
						</Menu.Item>
					)}
				</Menu>
				{selectedFilters.length > 0 && (
					<DrawerContainer
						title={
							<Typo type="primary" level={6}>
								Filtros aplicados
							</Typo>
						}
						placement="left"
						closable={false}
						onClose={onCloseFilterList}
						open={openFilterList}
						getContainer={false}
					>
						<div style={{ height: 170 }}>
							{selectedFilters.map((filter, index) => (
								<div
									key={index}
									onClick={() => handleFilterRemove(filter)}
									style={{
										cursor: "pointer",
										height: 30,
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Typo level={7} type="muted">
										{filter.label}
									</Typo>
									<CloseCircleOutlined style={{ color: COLORS.Danger }} />
								</div>
							))}
						</div>
						<div
							onClick={() => onCloseFilterList()}
							style={{
								position: "absolute",
								bottom: 5,
								display: "flex",
								justifyContent: "center",
								alignItems: "flex-end",
								width: "75%",
								cursor: "pointer",
							}}
						>
							<Typo type="muted" level={7}>
								Cerrar
							</Typo>
						</div>
					</DrawerContainer>
				)}
			</Sider>
			<Layout className="site-layout">
				<Inner>
					{/* {userdata?.guideProgress === 5 && (
						<SignInTemplate.AntdButton
							type="primary"
							bg="Primary"
							color="White"
							icon={<QuestionCircleOutlined />}
							onClick={handleBackToTheGuide}
							style={{
								width: "250px",
								fontWeight: "400",
								marginTop: "40px",
								marginLeft: "20px",
							}}
						>
							Volver a la Guia de Inicio
						</SignInTemplate.AntdButton>
					)} */}
					{sellerDashboardDisplay === CONSTANTS.DASHBOARD_SALES &&
						(generalInfoD2 ? (
							<SaleDashboard
								dashboard={generalInfoD2}
								optionsPie={pieDataD2}
								timeSalesGraph={timeSalesGraphD2}
								timeOrderGraph={timeOrdersGraphD2}
								timeUnitsGraph={timeUnitsGraphD2}
								distributors={distributorsD2}
								selectDistributor={handleSelectDistributor}
								handleDateChange={handleSelectedDateD2}
								deleteFilters={handleDeleteFilters}
								isLoading={isLoading}
								selectedDistributor={selectedDistributor}
								rangeDate={rangeDateD2}
								selectOrdersInfo={handleOrdersInfoSelect}
								ordersInfoSelector={ordersInfoSelector}
								selectDistributorsInfo={handleDistributorsPieInfoSelect}
								distributorsInfoSelector={distributorsPieInfoSelector}
								optionsPie2={secondPieDataD2}
								optionsPie3={thirdPieDataD2}
								selectedCategory={selectedCategory}
								selectCategory={handleSelectCategory}
								categories={categoriesD2}
								selectedChain={selectedChain}
								selectChain={handleSelectChain}
								chains={chainD2}
								userdata={userdata}
								sellers={usersD2}
								selectSeller={handleSelectSeller}
								selectedSeller={selectedSellerList}
								timeCategoriesSalesGraph={timeCategoriesSalesGraphD2}
								timeCategoriesUnitsGraph={timeCategoriesUnitsGraphD2}
								categoryGraphSelector2={categoryGraphSelector2D2}
								selectCategoryGraph2={handleCategoryGraphSelect2D2}
								timeHistoricSalesGraph={timeHistoricSalesGraphD2}
								selectSalesInfo={salesInfoSelectorD2}
								salesInfoSelector={handleSalesInfoSelectD2}
								salesPeriod={salesPeriod}
								selectSalesPeriod={handleSalesPeriodChange}
								handleApplyFilters={handleApplyFilters}
							/>
						) : (
							<LoadingSkeleton />
						))}
					{sellerDashboardDisplay === CONSTANTS.DASHBOARD_MOBILE &&
						(generalInfoD3 ? (
							<MobileDashboard
								dashboard={generalInfoD3}
								distributors={distributorsD3}
								selectDistributor={handleSelectDistributor}
								handleDateChange={handleSelectedDateD3}
								deleteFilters={handleDeleteFilters}
								isLoading={isLoading}
								selectedDistributor={selectedDistributor}
								posOrderingGraph={timePharmacyOrdersGraphD3}
								selectSeller={handleSelectSeller}
								sellers={usersD3}
								sellersTable={sellerSalesTableD3}
								selectedSeller={selectedSellerList}
								selectPeriod={handlePeriodChange}
								rangeDate={rangeDateD3}
								mobilePeriod={mobilePeriod}
								userdata={userdata}
								selectedCategory={selectedCategory}
								selectCategory={handleSelectCategory}
								categories={categoriesD3}
								handleApplyFilters={handleApplyFilters}
							/>
						) : (
							<LoadingSkeleton />
						))}
					{sellerDashboardDisplay === CONSTANTS.DASHBOARD_PHARMACY &&
						(generalInfoD4 ? (
							<PharmacyDashboard
								distributors={distributorsD4}
								selectDistributor={handleSelectDistributor}
								pharmacies={pharmaciesD4}
								selectPharmacy={handleSelectPharmacy}
								handleDateChange={handleSelectedDateD4}
								deleteFilters={handleDeleteFilters}
								isLoading={isLoading}
								selectedDistributor={selectedDistributor}
								selectedPharmacy={selectedPharmacy}
								pharmaciesTable={pharmaciesTable}
								rangeDate={rangeDateD4}
								selectedChain={selectedChain}
								selectChain={handleSelectChain}
								chains={chainsD4}
								userdata={userdata}
								selectedCategory={selectedCategory}
								selectCategory={handleSelectCategory}
								categories={categoriesD4}
								sellers={usersD4}
								selectSeller={handleSelectSeller}
								selectedSeller={selectedSellerList}
								pharmaciesPeriod={pharmaciesPeriod}
								selectPharmaciesPeriod={handlePharmaciesPeriodChange}
								handleApplyFilters={handleApplyFilters}
							/>
						) : (
							<LoadingSkeleton />
						))}
					{sellerDashboardDisplay === CONSTANTS.DASHBOARD_PRODUCTS &&
						(generalInfoD5 ? (
							<ProductDashboard
								distributors={distributorsD5}
								selectDistributor={handleSelectDistributor}
								handleDateChange={handleSelectedDateD5}
								deleteFilters={handleDeleteFilters}
								isLoading={isLoading}
								selectedDistributor={selectedDistributor}
								productsTable={productsTable}
								rangeDate={rangeDateD5}
								selectedChain={selectedChain}
								selectChain={handleSelectChain}
								chains={chainsD5}
								selectedBrand={selectedBrand}
								selectBrand={handleSelectBrand}
								brands={brandsD5}
								selectedCategory={selectedCategory}
								selectCategory={handleSelectCategory}
								categories={categoriesD5}
								handleDownloadProductsTable={handleDownloadProductsTable}
								sellers={usersD5}
								selectSeller={handleSelectSeller}
								selectedSeller={selectedSellerList}
								userdata={userdata}
								productsPeriod={productsPeriod}
								selectProductsPeriod={handleProductsPeriodChange}
								handleApplyFilters={handleApplyFilters}
							/>
						) : (
							<LoadingSkeleton />
						))}
					{sellerDashboardDisplay === CONSTANTS.DASHBOARD_INITIATIVES &&
						(generalInfoD6 ? (
							<InitiativeDashboard
								dashboard={generalInfoD6}
								distributors={distributorsD6}
								selectDistributor={handleSelectDistributor}
								handleDateChange={handleSelectedDateD6}
								deleteFilters={handleDeleteFilters}
								isLoading={isLoading}
								selectedDistributor={selectedDistributor}
								rangeDate={rangeDateD6}
								selectedChain={selectedChain}
								selectChain={handleSelectChain}
								chains={chainsD6}
								selectedCategory={selectedCategory}
								selectCategory={handleSelectCategory}
								categories={categoriesD6}
								sellers={usersD6}
								selectSeller={handleSelectSeller}
								selectedSeller={selectedSellerList}
								userdata={userdata}
								initiatives={initiativesD6}
								selectInitiative={handleSelectInitiative}
								selectedInitiative={selectedInitiative}
								productTotalvsInitiatives={productTotalvsInitiativesD6}
								timeInitiativesSalesGraph={timeInitiativesSalesGraphD6}
								timeInitiativesUnitsGraph={timeInitiativesUnitsGraphD6}
								initiativeGraphSelector={initiativeGraphSelectorD6}
								selectInitiativeGraph={handleInitiativeGraphSelectD6}
								initiativesPeriod={initiativesPeriod}
								selectInitiativesPeriod={handleInitiativesPeriodChange}
								handleApplyFilters={handleApplyFilters}
							/>
						) : (
							<LoadingSkeleton />
						))}
					{sellerDashboardDisplay === CONSTANTS.DASHBOARD_CHAIN &&
						(generalInfoD7 ? (
							<ChainDashboard
								distributors={distributorsD7}
								selectDistributor={handleSelectDistributor}
								handleDateChange={handleSelectedDateD7}
								deleteFilters={handleDeleteFilters}
								isLoading={isLoading}
								selectedDistributor={selectedDistributor}
								chainsTable={chainsTable}
								rangeDate={rangeDateD7}
								selectedChain={selectedChain}
								selectChain={handleSelectChain}
								chains={chainsD7}
								userdata={userdata}
								selectedCategory={selectedCategory}
								selectCategory={handleSelectCategory}
								categories={categoriesD7}
								sellers={usersD7}
								selectSeller={handleSelectSeller}
								selectedSeller={selectedSellerList}
								chainsPeriod={chainsPeriod}
								selectChainsPeriod={handleChainsPeriodChange}
								handleApplyFilters={handleApplyFilters}
							/>
						) : (
							<LoadingSkeleton />
						))}
				</Inner>
			</Layout>
		</Layout>
	);
}
